import React from 'react';
import { useIntl } from 'react-intl';
import { ProductDetails } from './previewFiles.types';
import { Button, Text } from '../../../../../../../UILibrary';
import { definedTranslation } from '../../../i18n';

type ProductDetailsSectionProps = {
  productDetails: ProductDetails;
};

export function ProductDetailsSection({
  productDetails,
}: ProductDetailsSectionProps) {
  const intl = useIntl();

  if (!productDetails?.thumbnailImageUrl || !productDetails?.name) {
    return null;
  }

  const handleLearnMoreClick = () => {
    if (!!productDetails?.url) {
      window.location.href = productDetails?.url;
    }
  };

  return (
    <div className="px-6 pt-6 pb-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          {productDetails.thumbnailImageUrl && (
            <img
              style={{ width: '72px', height: '72px' }}
              src={productDetails.thumbnailImageUrl}
              alt={productDetails.name || 'Product thumbnail'}
              className="w-full h-auto object-cover rounded-md w-18 h-18"
            />
          )}
        </div>

        <div className="flex-grow">
          {/* Product name */}
          {productDetails.manufacturer && (
            <Text
              variant="Caption1"
              className="text-[#4D4E58] font-bold leading-[20px]"
            >
              {productDetails.manufacturer}
            </Text>
          )}

          {/* Manufacturer */}
          {productDetails.name && (
            <Text variant="Caption2" className="text-[#4D4E58] leading-[20px]">
              {productDetails.name}
            </Text>
          )}

          <Button
            className="h-[28px] w-[94px] text-[13px] mt-[4px]"
            variant="secondary"
            onClick={handleLearnMoreClick}
          >
            {intl?.formatMessage(definedTranslation.previewFiles.learnMoreBtn)}
          </Button>
        </div>
      </div>
    </div>
  );
}
